import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      padding: [Spacings.s64, Spacings.s0],

      [BreakPointsMedia.LG]: {
        padding: [Spacings.s40, Spacings.s0],
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s64, Spacings.s0],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },

    title: {
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      maxWidth: 856,
      margin: [Spacings.s0, 'auto', Spacings.s48],
      fontSize: FontSizes.s30,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',
      lineHeight: LineHeights.l36,
      color: TextColors.tint1,
      overflow: 'hidden',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        lineClamp: 4,
        margin: [Spacings.s0, 'auto', Spacings.s32],
        textAlign: 'left',
        maxWidth: 456,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        lineClamp: 5,
        margin: [Spacings.s0, 'auto', Spacings.s24],
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },

    containerHolder: {
      display: 'grid',
      gridTemplateColumns: '5fr 5fr',
      gridGap: Spacings.s40,
      width: '100%',

      [BreakPointsMedia.LG]: {
        gridTemplateColumns: '6fr 6fr',
        gridGap: Spacings.s32,
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        gridTemplateColumns: '1fr',
        margin: [Spacings.s0, 'auto'],
        maxWidth: 456,
      },
    },

    container: {
      listStyleType: 'none',
    },

    column: {
      display: 'flex',
      minHeight: 68,
      marginBottom: Spacings.s32,
      position: 'relative',
      alignItems: 'center',
      '&.with-title': {
        alignItems: 'flex-start',
      },

      '&:last-child': {
        marginBottom: Spacings.s0,
      },

      [BreakPointsMedia.LG]: {
        marginBottom: Spacings.s24,
      },
    },

    number: {
      display: 'inline-block',
      minWidth: 68,
      width: 68,
      height: 68,
      borderRadius: CornerRadius.circle,
      border: `1px solid ${BackgroundColors.tint3}`,
      marginRight: Spacings.s40,
      fontWeight: FontWeights.normal,
      fontSize: FontSizes.s20,
      color: TextColors.tint1,
      textAlign: 'center',
      lineHeight: '66px',

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        minWidth: 48,
        width: 48,
        height: 48,
        fontSize: FontSizes.s16,
        marginRight: Spacings.s24,
        lineHeight: LineHeights.l48,
      },
    },

    stepWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },

    stepTitle: {
      display: '-webkit-box',
      lineClamp: 1,
      boxOrient: 'vertical',
      marginBottom: Spacings.s4,
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l32,
      color: TextColors.tint1,
      overflow: 'hidden',

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        lineClamp: 2,
      },
    },

    desc: {
      display: '-webkit-box',
      lineClamp: 6,
      boxOrient: 'vertical',
      width: '100%',
      fontWeight: FontWeights.normal,
      fontSize: FontSizes.s16,
      lineHeight: LineHeights.l24,
      color: TextColors.tint1,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s14,
        lineHeight: LineHeights.l20,
      },
    },
    // Skeleton
    skeletonTitle: {
      extend: 'title',
      width: '100%',
      height: 40,
    },
    skeletonStepWrapper: {
      maxWidth: 380,
      width: '100%',
      '& > i': {
        height: 32,
      },
    },
  }),
  {
    name: 'how-to-old-version',
  },
);

export default useStyles;
